import { Option } from '@common/types';
import { isObject } from 'lodash';

export function isOption(option: any): option is Option {
  return (isObject(option) && 'value' in option && 'label' in option);
}
